import React from "react";
import styled, { keyframes } from "styled-components";
import {
  FaBuilding,
  FaUniversity,
  FaUserShield,
  FaMoneyCheckAlt,
  FaGavel,
} from "react-icons/fa";

/**
 * CounterpartyTrustSection
 * - Image made smaller (max-width + smaller grid share)
 * - Tiles closer together (smaller gap/padding/line-height)
 */

const CounterpartyTrustSection = () => {
  return (
    <Section>
      <Header>
        <h2>Weryfikacja wiarygodności kontrahenta</h2>
        <p>
          Uzyskaj szczegółowe dane rejestrowe oraz ocenę finansowo - prawną
          istniejącego lub przyszłego kontrahenta w jednym kompletnym raporcie.
        </p>
      </Header>

      <Content>
        {/* LEFT: tiles only (icon + title) */}
        <LeftCol>
          <Tiles>
            <Tile>
              <IconWrap>
                <FaBuilding />
              </IconWrap>
              <TileTitle>KRS/CEIDG, GUS/REGON, VIES, Biała Lista</TileTitle>
            </Tile>

            <Tile>
              <IconWrap>
                <FaUniversity />
              </IconWrap>
              <TileTitle>Status VAT i rachunki do płatności</TileTitle>
            </Tile>

            <Tile>
              <IconWrap>
                <FaUserShield />
              </IconWrap>
              <TileTitle>AML, KYC, Listy sankcyjne, KNF, UOKiK, PEP</TileTitle>
            </Tile>

            <Tile>
              <IconWrap>
                <FaMoneyCheckAlt />
              </IconWrap>
              <TileTitle>Finanse, rating kredytowy, limit</TileTitle>
            </Tile>

            <Tile>
              <IconWrap>
                <FaGavel />
              </IconWrap>
              <TileTitle>Wierzytelności i zdarzenia prawne</TileTitle>
            </Tile>
          </Tiles>
        </LeftCol>

        {/* RIGHT: image */}
        <RightCol>
          <ImageWrapper>
            <img src="./banner1.jpg" alt="Jak to działa - ilustracja" />
          </ImageWrapper>
        </RightCol>
      </Content>
    </Section>
  );
};

export default CounterpartyTrustSection;

/* ================== styles ================== */

const MAIN_TEAL = "#3bc3cc";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Section = styled.section`
  position: relative;
  padding: 2rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  overflow: hidden;
`;

const Header = styled.div`
  max-width: 1100px;
  margin: 0 auto 1.5rem auto;
  text-align: center;
  background: transparent;

  h2 {
    font-size: 2.2rem;
    line-height: 1.2;
    margin: 0 0 0.5rem;
    color: #1f2937;
  }
  p {
    color: #475569;
    font-size: 1rem;
    margin: 0 auto;
    max-width: 900px;
  }
`;

const Content = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr; /* smaller image column */
  gap: 1rem;
  background: transparent;

  @media (max-width: 980px) {
    grid-template-columns: 1fr; /* stack on mobile */
  }
`;

const LeftCol = styled.div`
  display: grid;
  background: transparent;
`;

const Tiles = styled.div`
  display: grid;
  grid-template-columns: 1fr; /* one per row */
  gap: 0.55rem;               /* tighter vertical spacing */
  background: transparent;
`;

const Tile = styled.div`
  background: transparent;
  border-radius: 14px;
  padding: 0.7rem 0.9rem;     /* tighter padding */
  display: flex;
  align-items: center;
  gap: 0.6rem;                /* icons a bit closer to text */
  box-shadow: none;
  animation: ${fadeUp} 0.45s ease both;
`;

const IconWrap = styled.div`
  font-size: 1.15rem;         /* smaller icon */
  width: 2.2rem;
  height: 2.2rem;
  display: grid;
  place-items: center;
  border-radius: 10px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #ffffff 0%, ${MAIN_TEAL} 100%);
  color: ${MAIN_TEAL};
  box-shadow: 0 5px 14px rgba(59, 195, 204, 0.22);
`;

const TileTitle = styled.h3`
  font-size: 0.98rem;         /* slightly smaller text */
  line-height: 1.25;          /* tighter line height */
  margin: 0;
  color: #0f172a;
`;

const RightCol = styled.div`
  display: grid;
  place-items: center;         /* keep image centered in its smaller column */
  background: transparent;
`;

const ImageWrapper = styled.div`
  animation: ${fadeUp} 0.45s ease both;
  background: transparent;
  width: 100%;
  display: grid;
  place-items: center;

  img {
    width: 80%;               /* make image smaller */
    max-width: 420px;         /* hard cap to keep it modest on large screens */
    height: auto;
    border-radius: 12px;
    object-fit: contain;
    display: block;
  }
`;
